module.exports = __webpack_public_path__ + "static/media/map_arrival_station_icon_mini.98fb8664.svg";